import * as React from 'react';
// import LazyLoad from 'react-lazyload';

import Link from 'next/link';
import { StyledImage, StyledSVG, StyledNonSVG } from './style';
// import PlaceholderImage from '../../../static/images/placeholder.svg';

var CustomImage = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var src = props.src,
    alt = props.alt,
    width = props.width,
    height = props.height,
    href = props.href,
    responsive = props.responsive,
    rounded = props.rounded,
    opacity = props.opacity,
    filter = props.filter,
    onClick = props.onClick,
    svg = props.svg,
    className = props.className,
    color = props.color,
    fitCover = props.fitCover,
    draggable = props.draggable;
  var Cmp = /*#__PURE__*/React.createElement(StyledImage, {
    ref: ref,
    className: className,
    src: src,
    alt: alt || src,
    imageWidth: width,
    imageHeight: height,
    responsive: responsive,
    rounded: rounded,
    opacity: opacity,
    filter: filter,
    onClick: onClick,
    fitCover: fitCover,
    draggable: draggable,
    onError: function onError(e) {
      e.target.onerror = null;
      e.target.src = '/images/placeholder.svg';
      e.target.style.objectFit = 'cover';
    }
  });
  if (svg && typeof window !== 'undefined') {
    Cmp = /*#__PURE__*/React.createElement(StyledSVG, {
      ref: ref,
      className: className,
      src: src,
      alt: alt || src,
      width: width,
      height: height,
      responsive: responsive,
      rounded: rounded,
      opacity: opacity,
      filter: filter,
      onClick: onClick
    }, "Your browser doesn't support XHR or inline SVGs.");
  }
  if (color && svg && typeof window === 'undefined') {
    Cmp = /*#__PURE__*/React.createElement(StyledNonSVG, {
      ref: ref,
      src: src,
      alt: alt || src,
      width: width,
      height: height,
      responsive: responsive,
      rounded: rounded,
      opacity: opacity,
      filter: filter,
      onClick: onClick,
      color: color,
      fitCover: fitCover,
      draggable: draggable
    });
  }
  var Clicable = /*#__PURE__*/React.createElement(Link, {
    href: href || '#0',
    passHref: true
  }, /*#__PURE__*/React.createElement('a', {
    href: '#0'
  }, Cmp));

  // if (typeof window !== 'undefined') {
  //   if (svg) {
  //     return <React.Fragment>{href ? Clicable : Cmp}</React.Fragment>;
  //   }
  //   return <LazyLoad>{href ? Clicable : Cmp}</LazyLoad>;
  // }

  return /*#__PURE__*/React.createElement(React.Fragment, null, href ? Clicable : Cmp);
});
CustomImage.displayName = 'CustomImage';
CustomImage.defaultProps = {
  className: null,
  alt: '',
  href: null,
  responsive: false,
  rounded: null,
  opacity: null,
  filter: null,
  width: '100%',
  height: null,
  onClick: null,
  svg: null,
  color: null,
  fitCover: false,
  draggable: true
};
export default CustomImage;